import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

const TOKEN_FILE = 'session_token.txt';

/**
 * Enregistre le token dans le localStorage et dans le stockage natif de l'appareil.
 */
export const saveToken = async (token: string) => {
    localStorage.setItem('nexus_token', token);
    if (Capacitor.isNativePlatform()) {
        try {
            await Filesystem.writeFile({
                path: TOKEN_FILE,
                data: token,
                directory: Directory.Cache,
                encoding: Encoding.UTF8,
            });
            console.log("[TOKEN-STORAGE] Jeton synchronisé sur l'appareil.");
        } catch (e) {
            console.error("[TOKEN-STORAGE] Erreur écriture jeton fichier:", e);
        }
    }
};

/**
 * Récupère le token depuis le stockage natif ou le localStorage.
 */
export const loadToken = async (): Promise<string | null> => {
    let token = localStorage.getItem('nexus_token');
    
    // Si absent du localStorage mais sur mobile, on lit le fichier natif
    if (!token && Capacitor.isNativePlatform()) {
        try {
            const result = await Filesystem.readFile({
                path: TOKEN_FILE,
                directory: Directory.Cache,
                encoding: Encoding.UTF8,
            });
            token = result.data as string;
            if (token) {
                localStorage.setItem('nexus_token', token);
                console.log("[TOKEN-STORAGE] Jeton restauré depuis l'appareil.");
            }
        } catch (e) {
            // Le fichier n'existe pas encore ou est vide, c'est normal au premier démarrage
        }
    }
    return token;
};

/**
 * Supprime le token du localStorage et du stockage natif (déconnexion).
 */
export const removeToken = async () => {
    localStorage.removeItem('nexus_token');
    if (Capacitor.isNativePlatform()) {
        try {
            await Filesystem.deleteFile({
                path: TOKEN_FILE,
                directory: Directory.Cache,
            });
            console.log("[TOKEN-STORAGE] Jeton supprimé de l'appareil.");
        } catch (e) {
            // Fichier absent, ignoré
        }
    }
};
